import './App.css';

export function App() {
    return (
        <div className="DinMamma">
            <label className='DinMammaLabel'>DIN MAMMA</label>
        </div>
        );
}
export default App;